import { getActivityDetail, commitInfo, modifyInfo, getAdDetail } from "@/server/interfaces"

export default {
  namespaced: true,
  state: {
    activityCategorys: [],
    adDetail: {},
    worksTypes: [],
    commitSuccess: false
  },
  getters: {
    activityCategorys: state => state.activityCategorys,
    commitSuccess: state => state.commitSuccess,
    adDetail: state => state.adDetail,
    worksTypes: state => state.worksTypes
  },
  mutations: {
    updataCommitStatus(state, status) {
      state.commitSuccess = status
    },
    setActivityCategorys(state, dataList) {
      state.activityCategorys = dataList
    },
    setAdDetail(state, data) {
      state.adDetail = data
    },
    setWorksTypes(state, dataList) {
      state.worksTypes = dataList
    }
  },
  actions: {
    async commit({ commit, rootState }, option) {
      const activityId = rootState.activityInfo.activityId
      const userUuid = rootState.userInfo.userInfo.userUuid
      option.params.userUuid = userUuid
      option.params.activityId = activityId
      const IS_COMMIT_SUCCESS = await commitInfo(option)
      commit("updataCommitStatus", IS_COMMIT_SUCCESS)
    },
    async modify({ commit, rootState }, option) {
      const activityId = rootState.activityInfo.activityId
      const userUuid = rootState.userInfo.userInfo.userUuid
      option.params.userUuid = userUuid
      option.params.activityId = activityId
      const IS_COMMIT_SUCCESS = await modifyInfo(option)
      commit("updataCommitStatus", IS_COMMIT_SUCCESS)
    },
    async getActivityDataList({ commit, rootState }, option) {
      const activityId = rootState.activityInfo.activityId
      option.params.id = activityId
      const { activityCategorys, worksTypes } = await getActivityDetail(option)
      commit("setActivityCategorys", activityCategorys)
      commit("setWorksTypes", worksTypes)
    },
    async getAdDetailInfo({ commit, rootState }, option) {
      const activityId = rootState.activityInfo.activityId
      option.params.activityId = activityId
      const { contributePageTop } = await getAdDetail(option)
      commit("setAdDetail", contributePageTop)
    }
  }
}
